import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';

import s from './ImagePreviewLayout.scss';

export interface Props {
  className?: string;
  deviation?: PapiDeviation;
}

const ImagePreviewLayout: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
}) => {
  return <div className={classnames(s['root'], className)}>{children}</div>;
};
ImagePreviewLayout.displayName = 'ImagePreviewLayout';

export default ImagePreviewLayout;
